import { EDIT_LISTING_STEP } from 'site-modules/private-listing/constants/private-listing-steps';

export const getFormattedVehicleData = (offerData, style) => {
  const optionCodes = offerData?.vehicle?.selectedOptions?.map(option => option.id) || [];
  const options = style?.optionsWithOemCodes?.options || style?.options || [];
  const extColors = style?.optionsWithOemCodes?.exteriorColors || style?.exteriorColors || [];
  const intColors = style?.optionsWithOemCodes?.interiorColors || style?.interiorColors || [];

  const exteriorColor =
    extColors?.find(color => color.name === offerData?.vehicle?.exteriorColor) || offerData?.vehicle?.colors?.exterior;
  const interiorColor =
    intColors?.find(color => color.name === offerData?.vehicle?.interiorColor) || offerData?.vehicle?.colors?.interior;
  const selectedOptions = options?.filter(option => optionCodes?.includes(option.id)) || [];

  return {
    make: offerData?.vehicle?.make,
    makeNiceId: offerData?.vehicle?.makeSlug,
    model: offerData?.vehicle?.model,
    modelNiceId: offerData?.vehicle?.modelSlug,
    year: offerData?.vehicle?.year,
    trim: style?.trimName,
    mileage: offerData?.vehicle?.mileage,
    vin: offerData?.vin,
    styleId: offerData?.vehicle?.edmundsStyleId,
    style: offerData?.vehicle?.styleName,
    chromeIds: offerData?.vehicle?.chromeStyleIdList,
    selectedOptions,
    transmissionType: offerData?.vehicle?.transmissionType,
    engine: offerData?.vehicle?.engine,
    condition: offerData?.vehicle?.condition,
    drive: offerData?.vehicle?.drive,
    exteriorColor,
    interiorColor,
    zipCode: offerData?.seller?.zipCode,
    tmvOptionCodes: optionCodes?.join(','),
    filteredPartners: offerData?.partnersToSolicit || [],
  };
};

export const isEditMode = mode => mode === EDIT_LISTING_STEP;
